import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import Color from './Color';



interface ColorTableProps {
  data: Color[];
  columns: TableColumn<Color>[];
  customStyles: Record<string, any>;
}

const ColorTable: React.FC<ColorTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<Color>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default ColorTable;